export default __webpack_public_path__ + "static/media/fr.js.1a192c1f.map";